import { useEffect, useState } from "react";
import api from "@/lib/api";

const FALLBACK_TANGIBLE = ["Machinery", "Electronics", "Furniture & Fixtures", "Machinery Spare Part", "Vehicle", "Attachments and Jigs", "Other"];
const FALLBACK_INTANGIBLE = ["Software", "Antivirus", "Firewall", "License", "Other Intangibles"];

// Sep 2026 — single source of truth for asset categories: the Asset Registry
// category master (/asset-categories). Used by the asset form and every PO
// asset-spec dropdown so the lists can never drift apart.
export function useAssetCategories() {
  const [cats, setCats] = useState(null);
  useEffect(() => {
    api.get("/asset-categories").then(({ data }) => setCats(data || [])).catch(() => setCats([]));
  }, []);
  const live = cats && cats.length ? cats : null;
  const tangible = live ? live.filter((c) => c.asset_type === "tangible").map((c) => c.name) : FALLBACK_TANGIBLE;
  const intangible = live ? live.filter((c) => c.asset_type === "intangible").map((c) => c.name) : FALLBACK_INTANGIBLE;
  const all = [...tangible, ...intangible];
  const typeOf = (name) => (intangible.includes(name) ? "intangible" : "tangible");
  return { tangible, intangible, all, typeOf };
}
